import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://fbenvironnement.fr";

/**
 * Composant SEO réutilisable pour les pages publiques.
 * Définit title, description, canonical et Open Graph par page.
 */
export default function Seo({ title, description, path = "/", image }) {
  const fullTitle = title.includes("FB Environnement") ? title : `${title} | FB Environnement`;
  const url = `${SITE_URL}${path}`;
  const ogImage = image || `${SITE_URL}/og-image.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
